
import { supabase } from "@/integrations/supabase/client";

/**
 * Vérifie l'email d'un signataire de la charte et envoie l'email officiel
 */
export const verifyCharterSignatory = async (signatoryId: string, verificationToken: string) => {
  
  try {
// Appel de l'Edge Function (service role) pour vérifier sans RLS
    const { data: verificationResult, error: invokeError } = await supabase.functions.invoke('verify-charter-signatory', {
      body: { id: signatoryId, token: verificationToken }
    });

    if (invokeError) {
      console.error('[DEBUG verifyCharterSignatory] Erreur invoke:', invokeError);
      throw new Error('Impossible de vérifier votre email. Veuillez réessayer plus tard.');
    }

    if (!verificationResult || verificationResult.success !== true) {
      console.error('[DEBUG verifyCharterSignatory] Lien invalide ou déjà utilisé');
      throw new Error('Lien de vérification invalide ou déjà utilisé.');
    }

    if (verificationResult.alreadyVerified) {
      console.log('[DEBUG verifyCharterSignatory] La signature a déjà été vérifiée');
      return {
        success: true,
        alreadyVerified: true,
        redirectUrl: '/'
      };
    }

    
    console.log('[DEBUG verifyCharterSignatory] Vérification réussie, tentative d\'envoi de l\'email officiel');
    
    // Obtenir le nombre total de signatures pour le compteur
    const { data: countData } = await supabase
      .rpc('get_charter_signatures_count');
    
    const signatureCount = countData as number || 0;
    
    // L'email officiel (avec la charte personnalisée) est envoyé par le serveur
    // au moment de la vérification.
    return {
      success: true,
      signatureCount: signatureCount,
      signatureNumber: verificationResult.signatureNumber,
      emailSent: true,
      emailError: false,
      emailVerified: true,
      redirectUrl: '/'
    };
  } catch (error) {
    console.error('[DEBUG verifyCharterSignatory] Erreur attrapée:', error);
    throw error;
  }
}
